module.exports = new __parcel__URL__("battery_icon.c03fdc08.png").toString();